import { clearFirmSession } from '../auth/firmSession';
import { clearClientSession } from '../auth/clientSession';
import { unregisterPushInstallation } from './push';
import { flushSessionVault } from './sessionVault';
import { clearNativeDocumentCache } from './nativeFiles';

export async function clearPortalSession() {
  await unregisterPushInstallation();
  await clearNativeDocumentCache();
  clearFirmSession();
  clearClientSession();
  await flushSessionVault();
  window.dispatchEvent(new CustomEvent('portal-account-changed'));
}

export async function preparePortalLogin(role) {
  const hasOther = role === 'firm' ? localStorage.getItem('clientToken') : localStorage.getItem('accessToken');
  if (hasOther) await clearPortalSession();
}
